import { Injectable } from '@angular/core';
import API from '@aws-amplify/api';

@Injectable({
  providedIn: 'root'
})
export class AlarmasService {


  constructor() { 

  }

  public array_alarmas:Alarmas[]=[];
  public array_registro_alarmas: any;


  //----------------------------------------------   GET REGISTRO ALARMAS ----------------------------------------------  
  public async getRegistoAlarmas(patientID: string, timeini: number, timefin: number){
    const response = await this.getDataRegistroAlarmas(patientID, timeini, timefin);
    // console.log(response.data.Items);

    return response.data.Items; // Valor que devolvemos
  }


  public getDataRegistroAlarmas(patientID: string, timeini: number, timefin: number) { 
    const apiName = 'PharaonAmicareAlarms';
    const path = '/registroalarmas';
    const myInit = { // OPTIONAL
      headers: {     
        'Content-Type': 'application/json'
      }, // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {  // OPTIONAL
        patientID: patientID,
        timeini: timeini,
        timefin: timefin,
        option: "get",

      },
  };
  console.log("getDataRegistroAlarmas:")
    // console.log(API.get(apiName, path, myInit));
    return API.get(apiName, path, myInit);

  }

//----------------------------------------------   GET ALARMAS ----------------------------------------------  
  public async getAlarmas(espid: string){
    const response = await this.getData(espid);
    // console.log(response.data.Items);

    let estado:boolean = false;
    let isDisabled:boolean = false;
    let isExpanded:boolean = false;

    this.array_alarmas = [];

    for(let i=0; i < response.data.Count; i++ ){

      if(response.data.Items[i].estado == "false"){
        estado = false;
      }else{
        estado = true
      }
      if(response.data.Items[i].isDisabled == "false"){
        isDisabled = false;
      }else{
        isDisabled = true
      }
      if(response.data.Items[i].isExpanded == "false"){
        isExpanded = false;
      }else{
        isExpanded = true
      }

      this.array_alarmas.push({
        espid: response.data.Items[i].espid, 
        idpanel: response.data.Items[i].idpanel,
        carer: response.data.Items[i].carer,
        patientID: response.data.Items[i].patientID, //NEW
        isDisabled: isDisabled, 
        isExpanded: isExpanded,
        tipo: response.data.Items[i].tipo,
        horaIni: response.data.Items[i].horaIni,
        horaFin: response.data.Items[i].horaFin,
        estado: estado,
      });
    }
    // console.log(this.array_alarmas);

    return this.array_alarmas; // Valor que devolvemos
  }


  public getData(espid: string) { 
    const apiName = 'PharaonAmicareAlarms';
    const path = '/alarms';
    const myInit = { // OPTIONAL
      headers: {     
        'Content-Type': 'application/json'
      }, // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {  // OPTIONAL
        espid: espid,
        option: "get",

      },
  };
  // console.log("GET ALARMAS:")
    // console.log(API.get(apiName, path, myInit));
    return API.get(apiName, path, myInit);

  }

  //----------------------------------------------   DELETE ALARMA ----------------------------------------------  
  public async deleteAlarma(espid: string, idpanel: string){
    const response = await this.deleteData(espid, idpanel);
    return response.data.Items; // Valor que devolvemos
  }


  public deleteData(espid: string, idpanel: string) { 
    const apiName = 'PharaonAmicareAlarms';
    const path = '/alarms';
    const myInit = { // OPTIONAL
      headers: {     
        'Content-Type': 'application/json'
      }, // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {  // OPTIONAL
        espid: espid,
        idpanel: idpanel,
        option: "delete",

      },
  };

    return API.del(apiName, path, myInit);

  }


  //----------------------------------------------   ACTUALIZAR ALARMA ----------------------------------------------  
  public async updateAlarma(espid: string, idpanel: string, carer: string, horaIni: string, horaFin:string, estado:boolean, tipo:string){
    const response = await this.updateData(espid, idpanel, carer, horaIni, horaFin, estado, tipo);
    return response.data.Items; // Valor que devolvemos
  }


  public updateData(espid: string, idpanel: string, carer: string, horaIni: string, horaFin:string, estado:boolean, tipo: string) { 
    const apiName = 'PharaonAmicareAlarms';
    const path = '/alarms';
    const myInit = { // OPTIONAL
      headers: {     
        'Content-Type': 'application/json'
      }, // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {  // OPTIONAL
        espid: espid,
        idpanel: idpanel,
        carer: carer,
        tipo: tipo,
        horaIni: horaIni,
        horaFin: horaFin,
        isDisabled: false,
        isExpanded: false,
        estado: estado,
        option: "update",

      },
  };

    return API.post(apiName, path, myInit);

  }  

  //----------------------------------------------   CREAR ALARMA ----------------------------------------------  
  public async createAlarma(espid: string, idpanel: string, carer: string, patientID: string, horaIni: string, horaFin:string, estado:boolean, tipo:string){
    const response = await this.createData(espid, idpanel, carer, patientID, horaIni, horaFin, estado, tipo);
    return response.data.Items; // Valor que devolvemos
  }


  public createData(espid: string, idpanel: string, carer: string, patientID:string, horaIni: string, horaFin:string, estado:boolean, tipo:string) { 
    const apiName = 'PharaonAmicareAlarms';
    const path = '/alarms';
    const myInit = { // OPTIONAL
      headers: {     
        'Content-Type': 'application/json'
      }, // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {  // OPTIONAL
        espid: espid,
        idpanel: idpanel,
        carer: carer,
        patientID: patientID,// NEW
        tipo: tipo,
        horaIni: horaIni,
        horaFin: horaFin,
        isDisabled: false,
        isExpanded: false,
        estado: estado,
        option: "create",

      },
  };

    return API.put(apiName, path, myInit);

  }   



}

export interface Alarmas{
  espid: string;
  idpanel : string;
  carer : string;
  patientID: string; //NEW
  estado : boolean;
  horaFin : string;
  horaIni : string;
  isDisabled : boolean;
  isExpanded : boolean;
  tipo : string;

}
